export const SLUG_NUMBER_DIGITS = 6;
export const SLUG_NUMBER_MIN = 10 ** (SLUG_NUMBER_DIGITS - 1);
export const SLUG_NUMBER_MAX = 10 ** SLUG_NUMBER_DIGITS - 1;
export const SLUG_ADJECTIVES = [
    'airy',
    'amber',
    'ancient',
    'balmy',
    'beaming',
    'blooming',
    'bold',
    'breezy',
    'bright',
    'brisk',
    'budding',
    'calm',
    'cheerful',
    'cheery',
    'clever',
    'cosy',
    'crisp',
    'curious',
    'dappled',
    'dazzling',
    'dewy',
    'eager',
    'earthy',
    'elegant',
    'fair',
    'fearless',
    'fertile',
    'fragrant',
    'fresh',
    'friendly',
    'frosty',
    'gentle',
    'gleaming',
    'glossy',
    'golden',
    'graceful',
    'grand',
    'green',
    'happy',
    'hardy',
    'hearty',
    'honest',
    'humble',
    'jolly',
    'joyful',
    'keen',
    'kind',
    'leafy',
    'lively',
    'lofty',
    'lovely',
    'loyal',
    'lucky',
    'lush',
    'mellow',
    'merry',
    'mighty',
    'mild',
    'misty',
    'mossy',
    'nimble',
    'noble',
    'patient',
    'peaceful',
    'perky',
    'pleasant',
    'plucky',
    'polished',
    'proud',
    'quiet',
    'radiant',
    'rooted',
    'rugged',
    'rustling',
    'serene',
    'shady',
    'sheltered',
    'shimmering',
    'showy',
    'silver',
    'sleepy',
    'snug',
    'soft',
    'spirited',
    'splendid',
    'spry',
    'stately',
    'steady',
    'sturdy',
    'sunlit',
    'sunny',
    'supple',
    'swaying',
    'sweet',
    'tall',
    'tender',
    'thriving',
    'torrential',
    'tranquil',
    'trusty',
    'twining',
    'upright',
    'verdant',
    'vibrant',
    'vivid',
    'wandering',
    'warm',
    'whispering',
    'wild',
    'willing',
    'windy',
    'winding',
    'wise',
    'wabisabi',
    'woody',
    'young',
    'zen',
    'zesty',
];
export const SLUG_NOUNS = [
    'acorn',
    'alder',
    'apple',
    'ash',
    'aspen',
    'azalea',
    'bamboo',
    'banksia',
    'baobab',
    'basil',
    'beech',
    'bluebell',
    'blossom',
    'boronia',
    'bottlebrush',
    'bough',
    'bracken',
    'bramble',
    'branch',
    'brook',
    'bud',
    'buttercup',
    'callistemon',
    'camellia',
    'canopy',
    'cedar',
    'cherry',
    'chestnut',
    'clearing',
    'clematis',
    'clover',
    'creek',
    'cypress',
    'daisy',
    'dell',
    'dill',
    'elm',
    'eucalyptus',
    'fennel',
    'fern',
    'fig',
    'fir',
    'foxglove',
    'frangipani',
    'fuchsia',
    'gardenia',
    'glade',
    'gorse',
    'grevillea',
    'grove',
    'hawthorn',
    'hazel',
    'heather',
    'hemlock',
    'hibiscus',
    'hickory',
    'hollow',
    'holly',
    'honeysuckle',
    'hydrangea',
    'iris',
    'ivy',
    'jacaranda',
    'jasmine',
    'juniper',
    'larch',
    'laurel',
    'lavender',
    'leaf',
    'lichen',
    'lilac',
    'lily',
    'linden',
    'lotus',
    'lupin',
    'kumquat',
    'magnolia',
    'mahogany',
    'maple',
    'momiji',
    'marigold',
    'meadow',
    'mint',
    'moss',
    'mulberry',
    'myrtle',
    'olive',
    'orchid',
    'parsley',
    'peach',
    'pear',
    'pecan',
    'peony',
    'petal',
    'pine',
    'plum',
    'poppy',
    'poplar',
    'primrose',
    'quince',
    'redwood',
    'reed',
    'ridge',
    'root',
    'rosemary',
    'rowan',
    'sage',
    'sakura',
    'sapling',
    'sedge',
    'seedling',
    'sequoia',
    'sorrel',
    'spring',
    'spruce',
    'stream',
    'sycamore',
    'tamarind',
    'teak',
    'tendril',
    'thicket',
    'thistle',
    'thyme',
    'tree',
    'trellis',
    'trunk',
    'tulip',
    'twig',
    'vale',
    'violet',
    'walnut',
    'waratah',
    'wattle',
    'willow',
    'wisteria',
    'yarrow',
];
//# sourceMappingURL=tenant-slug.constants.js.map